export default __webpack_public_path__ + "static/media/Buckler of the Blood God.768f5aea.jpg";